import { Directive, Input, Output, EventEmitter } from "@angular/core";

export interface SortEvent {
    column: SortColumn;
    direction: SortDirection;
    secondaryColumn?: SortColumn;
    secondaryDirection?: SortDirection;
}

export type SortColumn = string | '' | 'name';
export type SortDirection = 'asc' | 'desc' | '';

const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': 'asc', '': 'asc' };

@Directive({
    selector: 'th[sortable]',
    host: {
        '[class.sort-asc]': 'direction === "asc"',
        '[class.sort-desc]': 'direction === "desc"',
        '(click)': 'rotate()'
    },
    standalone: false
})
export class NgbdSortableHeader {
    @Input() sortable: SortColumn = '';
    @Input() direction: SortDirection = '';
    @Output() sort = new EventEmitter<SortEvent>();

    rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.sortable, direction: this.direction });
    }
}
